import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white border-t py-4 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center text-gray-600 text-sm">
          <div className="mb-2 md:mb-0 uyghur-text">
            ئۇيغۇرچە سۆز زەنجىرى - بالىلار ئۈچۈن ئەڭ ياخشى ئويۇن
          </div>
          
          <div className="flex items-center">
            <span className="flex items-center">
              <Heart size={16} className="text-red-500 mr-1" />
              <span>UyghurKids</span>
            </span>
            <span className="mx-2">|</span>
            <span>{currentYear} ©</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;